import { render } from "./ColumnDetail.vue?vue&type=template&id=ab4ecab4&scoped=true&ts=true"
import script from "./ColumnDetail.vue?vue&type=script&lang=ts"
export * from "./ColumnDetail.vue?vue&type=script&lang=ts"

import "./ColumnDetail.vue?vue&type=style&index=0&id=ab4ecab4&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab4ecab4"]])

export default __exports__